import {
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  VISITOR_LIST,
  LOADER_FALSE,
  LOADER_CHECK,
  VISITOR_VIEW,
  VISITOR_I,
} from "../type";

const initialState = {
  VisitorTableData: [],
  ViewData: [],
  VisitorIndex: null,
  loader: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case VISITOR_LIST:
      return {
        ...state,
        VisitorTableData: action.payload,

      };
    case VISITOR_VIEW:
      return {
        ...state,
        ViewData: action.payload,

      };
    case VISITOR_I:
      return {
        ...state,
        VisitorIndex: action.payload,

      };
    case LOADER_CHECK:
      return {
        ...state,
        loader: true,
      };
  case LOADER_FALSE:
  return {
    ...state,
    loader: false,
  };
    default:
      return state;
  }
}
